export class PayerDetailsInput {
    constructor({
                    amount = '',
                    customerFullName = '',
                    customerEmail = '',
                    customerMobile = '',
                    invoiceNumber = '',
                    accountId = ''
                }) {
        this.amount = amount;
        this.customer_name = customerFullName;
        this.customer_email = customerEmail;
        this.customer_mobile = customerMobile;
        this.invoice_number = invoiceNumber;
        this.account_id = accountId;
    }
}

export const INITIAL_PAYER_DETAILS_INPUT = new PayerDetailsInput({
    amount: '',
    customer_name: '',
    customer_email: '',
    customer_mobile: '',
    invoice_number: '',
    account_id: ''
});
